import _sfc_main from "./component-library94.mjs";
import "./component-library95.mjs";
import normalizeComponent from "./component-library91.mjs";
var _sfc_render = function render() {
  var _vm = this, _c = _vm._self._c, _setup = _vm._self._setupProxy;
  return !_vm.text ? _c("p", { staticClass: "paragraph", class: _setup.classes }, [_vm._t("default")], 2) : _c("p", { staticClass: "paragraph", class: _setup.classes, domProps: { "innerHTML": _vm._s(_vm.text) } });
};
var _sfc_staticRenderFns = [];
var __component__ = /* @__PURE__ */ normalizeComponent(
  _sfc_main,
  _sfc_render,
  _sfc_staticRenderFns,
  false,
  null,
  "38b3068c",
  null,
  null
);
const Paragraph = __component__.exports;
export {
  Paragraph as default
};
